export const EMAILS = {
    ECSP: 'bok.ecsp@eurocash.pl',
    KPL: 'pomoc@kaucyjni.pl'
}